const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29 8h-1V2h1c.55 0 1-.45 1-1s-.45-1-1-1H7C4.24 0 2 2.24 2 5v22c0 2.76 2.24 5 5 5h22c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM7 2h19v2H7c-.55 0-1 .45-1 1s.45 1 1 1h19v2H7C5.35 8 4 6.65 4 5s1.35-3 3-3zm17 8v5.61l-1.68-.56a.971.971 0 00-.63 0l-1.69.56V10zm4 20H7c-1.65 0-3-1.35-3-3V8.98A4.98 4.98 0 007 10h11v7c0 .12.03.24.07.35.01.02.01.04.02.06.05.1.11.19.18.27l.05.05c.03.03.05.06.09.08.06.04.12.07.18.1.01 0 .01.01.02.01.11.05.23.06.34.07.01 0 .03.01.04.01s.02-.01.03-.01c.1 0 .19-.01.29-.05l2.69-.89 2.68.89c.09.03.19.04.29.05.01 0 .02.01.03.01s.02-.01.04-.01c.12 0 .23-.02.34-.07.01 0 .02-.01.03-.01.06-.03.12-.06.18-.1.03-.02.06-.05.09-.08.02-.02.04-.03.05-.05a.8.8 0 00.18-.27c.01-.02.02-.04.02-.06.04-.11.07-.23.07-.35v-7h2z"
});

const SvgEmptyCourseIcon = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyCourseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-course-icon.dcfe17b5.svg";
export { ForwardRef as ReactComponent };